import React, { useState, useEffect, Fragment } from "react";
import { TaskCategory, TaskCard, AddEditForm } from "../../";
import api from "../../../../apis/api";
import {
  PopUp,
  PopUpSuccess,
} from "../../../../components/adminSettings/assets/index";
import Notifications from "../../../../components/common/Notifications";
import Multiselect from 'multiselect-react-dropdown';
import Select from "react-select";
import MenuItem from "react-select";
import { Col,Row,Form,Input } from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
// ======================================= Category.

// ======================================= Parent.

const Board = ({ tasksOfProject ,emoplyeelist ,projectList }) => {
  const [allTaskOfProject, setAllTaskOfProject] = useState([]);
  const [allEmployee, setAllEmployee] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selAllTaskById,setselAllTaskById] = useState([]);
  const [selAllTaskN,setselAllTaskN] = useState([]);
  const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
  const [curDelId,setcurDelId] =useState(0);
  const [val,setval]=useState({value :"",label:""});
  const [error, setError] = useState(null);
  const [selAllTask, setselAllTask] = useState([]);
    const [selAllTaskSel, setselAllTaskSel] = useState([]);
  const [selProjectId,setselProjectId] = useState(null);

  const taskCategory = [
  
    {
      category: "New",
      bg: "bg-warning",
      id: 1,
      // listtask:selAllTask.filter(item => item.timeSheetStatus === 1),
    },
    {
      category: "In Progress",
      bg: "bg-info",
      id : 2,
      // listtask:selAllTask.filter(item => item.timeSheetStatus === 2),
    },
    {
      category: "Completed",
      bg: "bg-success",
      id : 3,
      // listtask:selAllTask.filter(item => item.timeSheetStatus === 3),
    },
    {
      category: "Assigned",
      bg: "bg-success",
      id : 4,
    },
    {
      category: "On Hold",
      bg: "bg-primary",
      id : 5,
    },
  ];
  const [loaded, setLoaded] = useState(false);
  const [isOpenForm, setIsOpenForm] = useState(false);
  const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;
  const [isOpenAddEditTask, setIsOpenAddEditTask] = useState({
    open: false,
    category: "",
  });

  useEffect(() => {
    setAllTaskOfProject(tasksOfProject);
    setAllEmployee(emoplyeelist);
    setselAllTaskN(selAllTask);
  }, [tasksOfProject,selAllTask],[emoplyeelist]);

  // Functions.

  const onDragOver = (e) => {
    e.preventDefault();
  };

  // from inner card.
  const onDragStart = (ev, element) => {
    var ele = JSON.stringify(element);
    ev.dataTransfer.setData("element", ele);
  };

  // drop handle.
  // on drop to the main category card.
  const onDrop = (e, category) => {
    let element = JSON.parse(e.dataTransfer.getData("element"));
    let updateAllTask = allTaskOfProject.map((el) =>
      el.taskId === element.taskId
        ? {
            ...el,
            status: category,
          }
        : el
    );

    setAllTaskOfProject(updateAllTask);
  };

  // toggle b/w AddEdit form and Task catagory card.
  const toggleAddEditForm = React.useCallback((category) => {
    if(selProjectId == null)
    {
     setError({ ...error, message: "First choose project...", status: 500 });
    }
    else
    {
      setIsOpenAddEditTask((prevState) => {
        return { open: !prevState.open, category: category };
      });
    }
    
  }, [selProjectId,setIsOpenAddEditTask]);

  // close add edit form.
  const toggleAddEditFormClose = React.useCallback(() => {
    setIsOpenAddEditTask((prevState) => {
      return { open: !prevState.open, category: "" };
    });
    setSelectedTask(null);
  }, []);
const handelAddTaskByLead =React.useCallback((formdata) =>{
  setLoaded(true);
  const res=api.task().AddEditEmployeeTimeSheetByLeder(formdata);
const fetchApi = async () => {
  let array=[];

  await api.task().GetAllTaskByProjectId(parseInt(selProjectId)).then((res) => array.push(res.data));
  setselAllTask(array[0]);

}
setTimeout(async () => { 
  fetchApi();
  setError({ ...error, message: "Task assigned successfully...", status: 200 });
  setLoaded(false);
}, 3000);
toggleAddEditFormClose();
},[setselAllTask,selProjectId])
  // handle select task.
  const handleSelectTask = (task, taskCategory) => {
 
    setSelectedTask(task);
    toggleAddEditForm(taskCategory.category);
  };
const handleDeleteTask =(task, taskCategory) =>{
  setisopenpopup((prevState) => !prevState);
  setcurDelId(task.employeeTimeSheetId);


}
const hadleDelWithPopYes =React.useCallback(() =>{
  // const res= delOfficeLoation(curDelId);
  const res=api.dailytask().deleteTaskByLeader(curDelId);
 
  toggleAddEditFormClose();
  
  setisopenpopup((prevState) => !prevState);
  setisopenpopupSuccess((prevState) => !prevState);
  // window.location.reload();
 
  }, [setselAllTaskById,setselAllTaskN,curDelId]);

const hadleDelWithPopNo =React.useCallback(() =>{
 setisopenpopup((prevState) => !prevState);

});
  
const hadleSuccessPop =React.useCallback(() =>{
  const fetchApi = async () => {
    let array=[];
    await api.task().GetAllTaskByProjectId(parseInt(selProjectId)).then((res) => array.push(res.data));
    setselAllTaskN(array[0]);
   
  }
  fetchApi();
   setError({ ...error, message: "Task deleted successfully...", status: 200 });
 setisopenpopupSuccess((prevState) => !prevState);

},[setselAllTaskN,selProjectId]);
const searchEmployee = React.useCallback(
  (searchVal) => {
    let tempArr = [];
    if (searchVal !== "") {
      // employee name search..
      selAllTask.map((el) =>
      el.issueTitle !==null ?  (el.issueTitle.toLowerCase().indexOf(searchVal.toLowerCase()) !==
        -1
          ? tempArr.includes(el)
            ? null
            : tempArr.push(el)
          : null) : null
      );

      setselAllTaskN(tempArr);
    } else {
      setselAllTaskN(selAllTask);
    }
  },
  [selAllTask,setselAllTask,setselAllTaskN]
);
const handleOnChangePrject =React.useCallback((id) =>{
  setselProjectId(id);
  const fetchApi = async () => {
    let array=[];
    await api.task().GetAllTaskByProjectId(parseInt(id)).then((res) => array.push(res.data));
    setselAllTask(array[0]);
  }
  fetchApi();
},[setselAllTask,setselProjectId]);


  return (
    <Form>
    <Row form>
      <Col md={6}>
      <Select
        className="basic-single"
        classNamePrefix="select"
        options={projectList} 
        placeholder="Select Project"
// selectedValues={selecteddepartment} 
onChange={(e) => {
  handleOnChangePrject(e.value);
}}

displayValue="label" // Property name to display in the dropdown options
/>
      </Col>
      <Col md={6}>
      <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Task...."
                  onChange={(e) => searchEmployee(e.target.value)}
                />
      </Col>
      </Row>
      <br/>

      <Row>
      <Col md={12}>
      <div className="task-board">
     

      {
        // loop through category.
        taskCategory.map((taskCat) => (
          
          <TaskCategory
            taskCategoryTitile={{
              title: taskCat.category,
              headingClass: taskCat.bg,
              // listtask:taskCat.listtask,
            }}
            onDragOver={onDragOver}
            onDrop={(e) => {
              onDrop(e, taskCat.category.toLowerCase());
            }}
          >
             {taskCat.category.toLowerCase() !== isOpenAddEditTask.category && (
              <div
                className="text-center"
                onClick={() =>
                  toggleAddEditForm(taskCat.category.toLowerCase())
                }
              >
                Add Task
              </div>
            )}
            {isOpenAddEditTask.open === true &&
              isOpenAddEditTask.category.toLowerCase() ===
                taskCat.category.toLowerCase() && (
                <div>
                  <AddEditForm
                    toggleAddEditFormClose={toggleAddEditFormClose}
                    handelAddTaskByLead={handelAddTaskByLead}
                    selectedTask={selectedTask}
                    employee={emoplyeelist}
                    selProjectId={selProjectId}
                    category={taskCat.category}
                  ></AddEditForm>
                </div>
              )}
              <br/>
            {/* Add Edit task for a particular category. ( completed, pending ...) */}
          

            {/* showing task card for a particular category, (completed, pending ...) */}
            {
              // status === category
              // isOpenAddEditTask.open === false &&
              // isOpenAddEditTask.category.toLowerCase() !==
              //   taskCat.category.toLowerCase() &&
                selAllTaskN
                  .filter(
                    (el) =>
                      el.timeSheetStatus ===
                      taskCat.id
                  )

                  .map((tasks) => (
                    <TaskCard
                      task={tasks}
                      employee={"avatar-01.jpg"}
                      onDragStart={(e) => onDragStart(e, tasks)}
                      handleSelectTask={() => handleSelectTask(tasks, taskCat)}
                      handleDeleteTask={() => handleDeleteTask(tasks,taskCat)}
                    ></TaskCard>
                  ))
            }
  
            {/*Dont not show Add Task Btn when isOpenAddEditTask.category !=== main card category (completed, pending ...)*/}
           
          </TaskCategory>
        ))
      }
     
    </div>
    </Col>
      </Row>
      <Notifications notifications={error}></Notifications>
      {isopenpopup == true ? (<PopUp 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUp>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
<DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
      </Form>
    
  );
};

export default Board;
